export default __webpack_public_path__ + "static/media/OliverBrochureFolder.ca584e6b.jpg";